<template lang="pug">
#modal-visualizacao-laudo
    el-dialog(
        :title="$t('mensagens.laudos.informarResultadosLaudo')",
        width='500px',
        top='5vh',
        :visible='show',
        @close='closeDialog()'
    )
        p.mb-1 {{ $t('mensagens.laudos.identificador') }}: {{ laudo.identificador }}
        p.mb-1 {{ $t('mensagens.laudos.beneficiario') }}: {{ laudo.beneficiario ? laudo.beneficiario : '--' }}

        hr

        h4.font-weight-bold {{ $t('mensagens.laudos.resultadoDaAnalise') }}
        .d-flex.flex-column.py-3
            el-radio(v-model='radio', label='conforme') {{ $t('mensagens.laudos.conforme') }}
            el-radio(v-model='radio', label='inconforme') {{ $t('mensagens.laudos.inconforme') }}

        h4.font-weight-bold.py-3 {{ $t('mensagens.laudos.uploadDeResultado') }}
        el-upload.upload-demo(
            action='#',
            drag,
            :file-list='fileList',
            :limit='1',
            :on-exceed='handleExceed',
            :auto-upload='false',
            accept='.pdf',
            :on-change='onLoadFile',
            :on-remove='onRemoveFile',
            ref='upload'
        )
            i.el-icon-upload
            .el-upload__text.w-100 {{ $t('mensagens.laudos.arrastePdf.1') }} <em>{{$t('mensagens.laudos.arrastePdf.2')}}</em>

        .d-flex.flex-direction.justify-content-between.py-3
            BaseButton(slot='footer', size='mini', @click='closeDialog') {{ $t('mensagens.comuns.voltar') }}
            BaseButton(
                slot='footer',
                size='mini',
                type='primary',
                :loading='loading',
                @click='inserirResultado'
            ) {{ $t('mensagens.comuns.finalizar') }}
</template>

<script>
import OperacaoLaudoService from '@/services/OperacaoLaudoService';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'ModalInsercaoResultados',

    components: {
        BaseButton
    },

    emits: ['atualizarListagem'],

    props: {
        laudo: {
            type: Object,
            required: true
        },
        show: {
            type: Boolean,
            required: true
        }
    },

    data() {
        return {
            radio: null,
            arquivoComResultado: null,
            fileList: [],
            loading: false
        };
    },

    methods: {
        closeDialog() {
            this.clearFields();
            this.$emit('update:show', false);
        },

        async inserirResultado() {
            if (!this.radio) {
                this.$notify.error({
                    message: this.$t('mensagens.laudos.resultadoDaAnaliseObrigatorio')
                });
                return;
            }

            if (!this.arquivoComResultado) {
                this.$notify.error({
                    message: this.$t('mensagens.laudos.arquivoComResultadoObrigatorio')
                });
                return;
            }

            const input = {
                id: this.laudo.id,
                status: this.radio,
                arquivo: this.arquivoComResultado.raw
            };

            this.loading = true;

            await OperacaoLaudoService.inserirResultado(input)
                .then(response => {
                    if (response.status === 200) {
                        this.$notify.success({
                            message: this.$t('mensagens.laudos.resultadoAdicionadoComSucesso')
                        });

                        this.closeDialog();
                        this.$emit('atualizarListagem');
                    }
                })
                .catch(() => {
                    this.$notify.error({
                        message: this.$t('mensagens.laudos.ocorreuUmErroAoAdicionarResultado')
                    });
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        onLoadFile(file) {
            this.arquivoComResultado = file;
        },

        onRemoveFile(file) {
            _.remove(this.fileList, o => {
                return o.uid === file.id;
            });
            this.arquivoComResultado = null;
        },

        handleExceed() {
            this.$notify.warning(this.$t('mensagens.laudos.limiteDeUmArquivoPdf'));
        },

        clearFields() {
            this.radio = null;
            this.arquivoComResultado = null;
            this.fileList = [];
        }
    }
};
</script>

<style lang="scss">
#modal-visualizacao-laudo {
    .el-dialog__footer {
        margin-top: -30px;
        display: flex;
        justify-content: flex-start;
    }

    .el-upload,
    .el-upload--text,
    .el-upload-dragger {
        width: 100%;
    }
}
</style>
